export default __webpack_public_path__ + "static/media/dataStructures.4e9f7d51.PNG";